import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import {
  FormControl, InputBase, MenuItem, Select, withStyles,
} from '@material-ui/core';
import './Dropdown.css';

export function ItensPerPageDropdown({ setItensPerPage, totalItens, setCurrentPage }) {
  const BootstrapInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid transparent',
      marginTop: '9%',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }))(InputBase);

  const [option, setOption] = useState(5);
  const handleChange = (e) => {
    setOption(e.target.value);
    if (totalItens > 0) {
      setItensPerPage(Number(e.target.value));
      setCurrentPage(0);
    }
  };

  return (
    <div>
      <FormControl className="paginationDropdown">
        <Select
          id="demo-customized-select-native"
          input={<BootstrapInput />}
          value={option}
          onChange={handleChange}
        >
          <MenuItem value={1}>1</MenuItem>
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={15}>15</MenuItem>
        </Select>
      </FormControl>
      {/*
      <FormControl>
        <NativeSelect
          id="demo-customized-select-native"
          input={<BootstrapInput />}
          defaultValue=""
          value={itens}
          onChange={handleChange}
        >
          <option value={1}>1</option>
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={15}>15</option>
        </NativeSelect>
      </FormControl> */}
    </div>
  );
}

ItensPerPageDropdown.propTypes = {
  items: PropTypes.element.isRequired,
  setItensPerPage: PropTypes.element.isRequired,
};
